import { AutomationCourse } from '../types';
import { module1 } from './modules/module1';
import { module2 } from './modules/module2';
import { module3 } from './modules/module3';

export const ZAPIER_COURSES: AutomationCourse[] = [
  {
    id: 'zapier-automation',
    title: 'Zapier Automation Mastery',
    description: 'Master no-code automation with Zapier. Connect 5,000+ apps, build multi-step workflows, and automate your business processes without coding.',
    level: 'beginner',
    duration: '6 hours',
    category: 'workflow-automation',
    image: '/api/placeholder/400/300',
    tags: ['Zapier', 'Automation', 'No-Code', 'Integration', 'Workflow', 'Productivity', 'SaaS'],
    prerequisites: [
      'Basic understanding of web applications',
      'Familiarity with common business tools',
      'No coding experience required'
    ],
    objectives: [
      'Create and manage automated workflows (Zaps)',
      'Connect multiple apps and services',
      'Build multi-step automations with filters',
      'Implement conditional logic and paths',
      'Transform data between applications',
      'Set up webhooks and custom integrations'
    ],
    learningOutcomes: [
      'Design efficient automation workflows',
      'Connect and integrate popular business apps',
      'Use filters and conditional logic effectively',
      'Transform and format data automatically',
      'Troubleshoot and optimize Zaps',
      'Implement best practices for automation',
      'Save time with no-code integrations'
    ],
    modules: [
      module1,
      module2,
      module3
    ],
    type: 'automation'
  }
];
